/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 drill.glb 
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export function Drill(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/drill/object/drill.glb");
  const { actions } = useAnimations(animations, group);
  useEffect(() => {
    console.log(actions);
    Object.entries(actions).forEach(([key, value]) => {
      actions[key].play();
    });
    console.log(actions);
    // actions.forEach((item) => {
    //   // actions[item].play();
    // });
    // actions["¸ðµû±â1.001|DSN-1S-V3|BaseLayer"].play();
  }, []);
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group
          name="Point001"
          position={[0, 2.1, 0]}
          rotation={[-Math.PI / 2, -1.571, 0]}
          scale={0.001}
        >
          <mesh
            name="Object001"
            geometry={nodes.Object001.geometry}
            material={materials["Material #27"]}
            position={[-71.5, 21.5, 0.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â3"
            geometry={nodes["¸ðµû±â3"].geometry}
            material={materials["Material #25"]}
            position={[-182.999, 21.7, 13.75]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ1"
            geometry={nodes["ÄÆ-µ¹Ãâ1"].geometry}
            material={materials["Material #26"]}
            position={[-140.999, -11.5, 16.45]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü1"
            geometry={nodes["È¸Àü1"].geometry}
            material={materials["Material #27"]}
            position={[-176.77, -32.088, -94.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â3001"
            geometry={nodes["¸ðµû±â3001"].geometry}
            material={materials["Material #25"]}
            position={[-98.999, -44.7, 13.75]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü1001"
            geometry={nodes["È¸Àü1001"].geometry}
            material={materials["Material #27"]}
            position={[-295.27, -87.088, -94.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü1002"
            geometry={nodes["È¸Àü1002"].geometry}
            material={materials["Material #27"]}
            position={[-176.77, -142.088, -94.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â2"
            geometry={nodes["¸ðµû±â2"].geometry}
            material={materials["Material #25"]}
            position={[-140.999, -46.201, -15.05]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â2001"
            geometry={nodes["¸ðµû±â2001"].geometry}
            material={materials["Material #25"]}
            position={[-141, -11.501, -26.05]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ1001"
            geometry={nodes["ÄÆ-µ¹Ãâ1001"].geometry}
            material={materials["Material #26"]}
            position={[-141, -11.501, -20.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â2002"
            geometry={nodes["¸ðµû±â2002"].geometry}
            material={materials["Material #25"]}
            position={[-141, 23.199, -15.05]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â1"
            geometry={nodes["¸ðµû±â1"].geometry}
            material={materials["Material #28"]}
            position={[-141, 23.199, -15.05]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¿øÇü_ÆÐÅÏ2"
            geometry={nodes["¿øÇü_ÆÐÅÏ2"].geometry}
            material={materials["Material #25"]}
            position={[-141, 23.199, -47.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â2003"
            geometry={nodes["¸ðµû±â2003"].geometry}
            material={materials["Material #25"]}
            position={[-140.999, -46.201, -53.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ2"
            geometry={nodes["ÄÆ-µ¹Ãâ2"].geometry}
            material={materials["Material #26"]}
            position={[-176.999, -62.751, -16.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â2004"
            geometry={nodes["¸ðµû±â2004"].geometry}
            material={materials["Material #25"]}
            position={[-141, 23.199, -53.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ2001"
            geometry={nodes["ÄÆ-µ¹Ãâ2001"].geometry}
            material={materials["Material #26"]}
            position={[-93.499, 43.5, 79.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ2002"
            geometry={nodes["ÄÆ-µ¹Ãâ2002"].geometry}
            material={materials["Material #26"]}
            position={[-93.499, -66.5, 79.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿52"
            geometry={nodes["ÇÊ·¿52"].geometry}
            material={materials["Material #26"]}
            position={[-140.999, -11.5, 79.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿8"
            geometry={nodes["ÇÊ·¿8"].geometry}
            material={materials["Material #26"]}
            position={[-148.249, -11.5, -59.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿1"
            geometry={nodes["ÇÊ·¿1"].geometry}
            material={materials["Material #29"]}
            position={[-140.999, -11.5, -47.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¿øÇü_ÆÐÅÏ1"
            geometry={nodes["¿øÇü_ÆÐÅÏ1"].geometry}
            material={materials["Material #29"]}
            position={[-140.999, -11.5, 26.35]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ1"
            geometry={nodes["º¸½º-µ¹Ãâ1"].geometry}
            material={materials["Material #30"]}
            position={[-182.499, -56.501, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿3"
            geometry={nodes["ÇÊ·¿3"].geometry}
            material={materials["Material #29"]}
            position={[-210.51, -47.247, 3.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿2"
            geometry={nodes["ÇÊ·¿2"].geometry}
            material={materials["Material #29"]}
            position={[-210.51, -47.247, -3.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â1001"
            geometry={nodes["¸ðµû±â1001"].geometry}
            material={materials["Material #31"]}
            position={[-210.51, -47.247, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü1003"
            geometry={nodes["È¸Àü1003"].geometry}
            material={materials["Material #25"]}
            position={[-157.899, -53.201, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü1004"
            geometry={nodes["È¸Àü1004"].geometry}
            material={materials["Material #25"]}
            position={[-124.1, 30.199, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿11"
            geometry={nodes["ÇÊ·¿11"].geometry}
            material={materials["Material #26"]}
            position={[-140.999, -11.5, 43.45]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿3001"
            geometry={nodes["ÇÊ·¿3001"].geometry}
            material={materials["Material #29"]}
            position={[-194.778, -7.021, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â1002"
            geometry={nodes["¸ðµû±â1002"].geometry}
            material={materials["Material #28"]}
            position={[-140.999, -46.201, -15.05]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¿øÇü_ÆÐÅÏ2001"
            geometry={nodes["¿øÇü_ÆÐÅÏ2001"].geometry}
            material={materials["Material #25"]}
            position={[-140.999, -46.201, -47.55]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¿øÇü_ÆÐÅÏ3"
            geometry={nodes["¿øÇü_ÆÐÅÏ3"].geometry}
            material={materials["Material #25"]}
            position={[-140.999, -11.5, -39.05]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿9"
            geometry={nodes["ÇÊ·¿9"].geometry}
            material={materials["Material #26"]}
            position={[-267.284, -47.968, 300.081]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿6"
            geometry={nodes["ÇÊ·¿6"].geometry}
            material={materials["Material #29"]}
            position={[-140.999, -11.5, 26.35]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ1002"
            geometry={nodes["ÄÆ-µ¹Ãâ1002"].geometry}
            material={materials["Material #27"]}
            position={[-140.999, -11.5, 68.4]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ1001"
            geometry={nodes["º¸½º-µ¹Ãâ1001"].geometry}
            material={materials["Material #28"]}
            position={[-140.999, -11.5, 35.85]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â2005"
            geometry={nodes["¸ðµû±â2005"].geometry}
            material={materials["Material #25"]}
            position={[-140.999, -11.5, 25.95]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement"
            geometry={nodes.TorqueElement.geometry}
            material={materials["Material #32"]}
            position={[-93.499, -66.5, 87.19]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement001"
            geometry={nodes.TorqueElement001.geometry}
            material={materials["Material #32"]}
            position={[-93.499, 43.5, 87.19]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement002"
            geometry={nodes.TorqueElement002.geometry}
            material={materials["Material #32"]}
            position={[-211.999, -11.5, 87.19]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement003"
            geometry={nodes.TorqueElement003.geometry}
            material={materials["Material #32"]}
            position={[-93.499, 43.5, -28.59]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement004"
            geometry={nodes.TorqueElement004.geometry}
            material={materials["Material #32"]}
            position={[-93.499, -66.5, -28.59]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement005"
            geometry={nodes.TorqueElement005.geometry}
            material={materials["Material #32"]}
            position={[-211.999, -11.5, -28.59]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ1002"
            geometry={nodes["º¸½º-µ¹Ãâ1002"].geometry}
            material={materials["Material #33"]}
            position={[-85.5, 0, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ1003"
            geometry={nodes["º¸½º-µ¹Ãâ1003"].geometry}
            material={materials["Material #27"]}
            position={[-140.999, -11.5, 68.7]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â1003"
            geometry={nodes["¸ðµû±â1003"].geometry}
            material={materials["Material #25"]}
            position={[-98.999, -44.7, 36.95]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="½ºÀ¬4"
            geometry={nodes["½ºÀ¬4"].geometry}
            material={materials["Material #28"]}
            position={[-98.999, -44.7, 29.95]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="½ºÀ¬4001"
            geometry={nodes["½ºÀ¬4001"].geometry}
            material={materials["Material #28"]}
            position={[-98.999, -44.7, 29.95]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="½ºÀ¬3"
            geometry={nodes["½ºÀ¬3"].geometry}
            material={materials["Material #27"]}
            position={[-182.999, 21.7, 31.467]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="½ºÀ¬5"
            geometry={nodes["½ºÀ¬5"].geometry}
            material={materials["Material #27"]}
            position={[-182.499, -56.501, -11.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ16"
            geometry={nodes["º¸½º-µ¹Ãâ16"].geometry}
            material={materials["Material #27"]}
            position={[-51.955, -17.837, 11.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement006"
            geometry={nodes.TorqueElement006.geometry}
            material={materials["Material #32"]}
            position={[-46.5, -11, -11.9]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="Fillet"
            geometry={nodes.Fillet.geometry}
            material={materials["Material #32"]}
            position={[-46.5, -11, 13]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ1003"
            geometry={nodes["ÄÆ-µ¹Ãâ1003"].geometry}
            material={materials["Material #27"]}
            position={[-46.5, -11, -4.59]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿20"
            geometry={nodes["ÇÊ·¿20"].geometry}
            material={materials["Material #26"]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿10"
            geometry={nodes["ÇÊ·¿10"].geometry}
            material={materials["Material #26"]}
            position={[-99.5, 0, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿10001"
            geometry={nodes["ÇÊ·¿10001"].geometry}
            material={materials["Material #26"]}
            position={[-99.5, 0, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ16001"
            geometry={nodes["º¸½º-µ¹Ãâ16001"].geometry}
            material={materials["Material #27"]}
            position={[-768.08, 25.7, -17.933]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement007"
            geometry={nodes.TorqueElement007.geometry}
            material={materials["Material #32"]}
            position={[-773.413, 2.3, -11]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="Fillet001"
            geometry={nodes.Fillet001.geometry}
            material={materials["Material #32"]}
            position={[-773.413, 27.2, -11]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ1004"
            geometry={nodes["ÄÆ-µ¹Ãâ1004"].geometry}
            material={materials["Material #27"]}
            position={[-773.413, 9.61, -11]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿20001"
            geometry={nodes["ÇÊ·¿20001"].geometry}
            material={materials["Material #26"]}
            position={[-819.913, 14.2, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿20002"
            geometry={nodes["ÇÊ·¿20002"].geometry}
            material={materials["Material #26"]}
            position={[-715.413, 14.2, 29.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÇÊ·¿20003"
            geometry={nodes["ÇÊ·¿20003"].geometry}
            material={materials["Material #26"]}
            position={[-715.413, 14.2, -29.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ3"
            geometry={nodes["º¸½º-µ¹Ãâ3"].geometry}
            material={materials["Material #28"]}
            position={[-729.913, 1.2, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="TorqueElement008"
            geometry={nodes.TorqueElement008.geometry}
            material={materials["Material #32"]}
            position={[-729.913, 33.64, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â1004"
            geometry={nodes["¸ðµû±â1004"].geometry}
            material={materials["Material #25"]}
            position={[-140.999, -11.5, 32.85]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="¸ðµû±â1005"
            geometry={nodes["¸ðµû±â1005"].geometry}
            material={materials["Material #25"]}
            position={[-182.999, 21.7, 38.85]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü3"
            geometry={nodes["È¸Àü3"].geometry}
            material={materials["Material #27"]}
            position={[-749.413, 14.7, 21.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü3001"
            geometry={nodes["È¸Àü3001"].geometry}
            material={materials["Material #27"]}
            position={[-749.413, 14.7, -21.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="È¸Àü3002"
            geometry={nodes["È¸Àü3002"].geometry}
            material={materials["Material #27"]}
            position={[-71.5, 21.5, 0.5]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ3"
            geometry={nodes["ÄÆ-µ¹Ãâ3"].geometry}
            material={materials["Material #35"]}
            position={[-90.362, -34.156, 62.769]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="ÄÆ-µ¹Ãâ5"
            geometry={nodes["ÄÆ-µ¹Ãâ5"].geometry}
            material={materials["Material #34"]}
            position={[-150.835, -37.195, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
          <mesh
            name="º¸½º-µ¹Ãâ1004"
            geometry={nodes["º¸½º-µ¹Ãâ1004"].geometry}
            material={materials["Material #28"]}
            position={[-140.999, -11.5, 34.59]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/drill/object/drill.glb");
